export default "__VITE_ASSET__793bc17a__"